import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: 'fr',
        // we init with resources
        resources: {
            fr: {
                translations: {

                    'MainPage_Intro_Header': "Sécurisez votre",
                    'MainPage_Intro_HeaderAccent': "stationnement",
                    'MainPage_Intro_HeaderEnd': "avec Max Park Solutions",

                    'MainPage_Intro_Txt': "Gestion de stationnement privé clé en main.",
                    'MainPage_Intro_Btn': "Payer un avis",

                    'MainPage_Location_Title': "Nous desservons votre région",

                    'MainPage_Mission_Title': "Notre mission, vous garantir des aires de stationnement sécuritaires et accessibles",
                    'MainPage_Mission_1_Title': "Conciliant",
                    'MainPage_Mission_1_Txt': "Une équipe respectueuse pour des aires de stationnement agréables et libres de conflits.",

                    'MainPage_Mission_2_Title': "Sécuritaire",
                    'MainPage_Mission_2_Txt': "Offrez la paix d’esprit à vos clients grâce à nos patrouilles de surveillance nocturnes.",

                    'MainPage_Mission_3_Title': "Accessible",
                    'MainPage_Mission_3_Txt': "Des places de stationnement facilement accessibles pour votre clientèle.",

                    'MainPage_Mission_4_Title': "Encadré",
                    'MainPage_Mission_4_Txt': "Un service clé en main, de la gestion à l’entretien.",

                    'MainPage_Services_Title': "Nos services",
                    'MainPage_Services_Txt': "Notre équipe met en place un service complet et sécuritaire.",

                    'MainPage_Services_1_Title': "Affichage & signalisation",
                    'MainPage_Services_1_List_1': "Création et installation d’affiches d’interdiction de stationnement.",
                    'MainPage_Services_1_List_2': "Mise en place d’espaces de stationnement réservés.",

                    'MainPage_Services_2_Title': "Gestion & Contrôle",
                    'MainPage_Services_2_List_1': "Gestion du trafic automobile",
                    'MainPage_Services_2_List_2': "Contrôle de l’accès à l’espace privé",
                    'MainPage_Services_2_List_3': "Émission de frais de stationnement",

                    'MainPage_Services_3_Title': "Remorquage & Assistance",
                    'MainPage_Services_3_List_1': "Remorquage disponible 24/7",
                    'MainPage_Services_3_List_2': "Localisation des véhicules remorqués",
                    'MainPage_Services_3_List_3': "Gestion des situations de crise",

                    'MainPage_Services_4_Title': "Sensibilisation & Prévention",
                    'MainPage_Services_4_List_1': "Sensibilisation auprès des contrevenants",
                    'MainPage_Services_4_List_2': "Présence aléatoire des agents sur les lieux",
                    'MainPage_Services_4_List_3': "Interventions pacifiques",

                    'MainPage_Soumission_Title': "Demande de soumission",
                    'MainPage_Soumission_Txt': "Vos espaces de stationnement seront exclusivement dédiés à vos clients. Notre équipe d’experts met en œuvre un service complet en appliquant des mesures préventives et dissuasives. Ensemble, nous veillons à la sécurité de votre aire de stationnement.",

                    'MainPage_Soumission_Form_Title': "Formulaire de",
                    'MainPage_Soumission_Form_Txt': "S’il vous plaît, soyez précis dans votre message.",

                    'MainPage_Form_Field_Name': "Nom",
                    'MainPage_Form_Field_Name_PlaceHolder': "Insérez votre nom et prénom",

                    'MainPage_Form_Field_Email': "Courriel",
                    'MainPage_Form_Field_Email_PlaceHolder': "Entrez votre courriel",

                    'MainPage_Form_Field_Enterprise': "Nom de l'entreprise",
                    'MainPage_Form_Field_Enterprise_PlaceHolder': "Entrez le nom de l'entreprise",

                    'MainPage_Form_Field_Phone': "Numéro de téléphone",
                    'MainPage_Form_Field_Phone_PlaceHolder': "Entrez un numéro de téléphone",

                    'MainPage_Form_Field_Message': "Message",
                    'MainPage_Form_Field_Message_PlaceHolder': "Écrivez votre message",

                    'MainPage_Form_Field_Submit': "Envoyer",

                    'MainPage_Form_ResponseTime': "Un représentant vous contactera dans un délai de 48 h",

                    'SearchPage_Intro_Header': "Payez un",
                    'SearchPage_Intro_HeaderAccent': "avis",
                    'SearchPage_Intro_HeaderEnd': "de stationnement",

                    'SearchPage_Intro_Txt': "Vous avez en votre possession un avis de frais de stationnement ?",
                    'SearchPage_Intro_Txt2': "Effectuez votre paiement dès maintenant.",

                    'SearchPage_Field_Searching_PlaceHolder': "(ex:1680812)",
                    'SearchPage_SearchBtn': "Rechercher",
                    'SearchPage_SearchBtn_Searching': "En cours...",


                    'ServicePage_Intro_Header': "Nos services sont",
                    'ServicePage_Intro_HeaderAccent': "personnalisables",
                    'ServicePage_Intro_HeaderEnd': "Tout pour répondre à vos besoins",

                    'ServicePage_Service_Section_Title': "Nos services",

                    'ServicePage_Service_1_Title': "Gestion du stationnement",
                    'ServicePage_Service_1_List_1': "Répondre aux appels de service",
                    'ServicePage_Service_1_List_2': "Effectuer des patrouilles",
                    'ServicePage_Service_1_List_3': "Fournir des vignettes aux détenteurs des véhicules autorisés",

                    'ServicePage_Service_2_Title': "Affichage et signalisation",
                    'ServicePage_Service_2_List_1': "Produire et installer les panneaux",
                    'ServicePage_Service_2_List_2': "Déterminer les limites des aires de stationnement",
                    'ServicePage_Service_2_List_3': "Rafraîchir la peinture des lignes de stationnement",

                    'ServicePage_Service_3_Title': "Patrouille",
                    'ServicePage_Service_3_List_1': "Présence d’un agent identifié sur place",
                    'ServicePage_Service_3_List_2': "Équipements technologiques modernes",
                    'ServicePage_Service_3_List_3': "Véhicules de patrouille disponibles 24/7",
                    'ServicePage_Service_3_List_4': "Émission et production de rapports détaillés",

                    'ServicePage_Service_4_Title': "Circulation",
                    'ServicePage_Service_4_List_1': "Fluidité de la circulation assurée par un agent en cas d’événements ou de travaux",
                    'ServicePage_Service_4_List_2': "Attribution d’espace de stationnement",
                    'ServicePage_Service_4_List_3': "Signalisation des espaces restants",

                    'ServicePage_Service_5_Title': "Avis frais de stationnement",
                    'ServicePage_Service_5_List_1': "Avis émis aux usagers qui contreviennent à la réglementation",
                    'ServicePage_Service_5_List_2': "Sensibilisation aux contrevenants aperçus en direct",

                    'ServicePage_Service_5_Title': "Surveillance nocturne",
                    'ServicePage_Service_5_List_1': "Véhicule de service avec gyrophare",
                    'ServicePage_Service_5_List_2': "Surveillance par auto-patrouille la nuit",
                    'ServicePage_Service_5_List_3': "Historique des utilisateurs nocturnes pour les récidivistes",

                    'ServicePage_Service_6_Title': "Remorquage",
                    'ServicePage_Service_6_List_1': "Remorquage des véhicules qui enfreignent les règlements",
                    'ServicePage_Service_6_List_2': "Remorquage des véhicules bloquant des accès importants",

                    'ServicePage_Soumission_Title': "Une aire de stationnement spécifique ? ",
                    'ServicePage_Soumission_SubTitle': "Faites-nous part de votre demande",
                    'ServicePage_Soumission_Txt': "services sur-mesure selon vos besoins !",
                    'ServicePage_Soumission_Btn': "Demande de soumission",

                    'ContactPage_Intro_Header': "Transmettez votre",
                    'ContactPage_Intro_HeaderAccent': "message",
                    'ContactPage_Intro_HeaderEnd': "à l'équipe MaxPark Solutions",

                    'ContactPage_SubSection_Title': "Vous avez une question ?",
                    'ContactPage_SubSection_SubTitle': "La réponse se trouve sûrement dans notre FAQ",

                    'ContactPage_FAQ_Title': "F.A.Q",
                    'ContactPage_FAQ_Txt': "Ici, nous avons rassemblé les réponses aux questions les plus fréquemment posées.",

                    'ContactPage_FAQ_1_Question': "Pourquoi est-ce que j’ai reçu un avis de frais de stationnement?",
                    'ContactPage_FAQ_1_1_Answer': "Parce que vous ne respectez pas la réglementation de la propriété privée où vous avez stationné votre véhicule. Référez-vous à votre avis pour voir le type de règlement qui n'a pas été respecté.",

                    'ContactPage_FAQ_2_Question': "Quelle est la liste des règlements ?",
                    'ContactPage_FAQ_2_1_Answer': "Stationnement de votre véhicule en dehors des heures d’ouverture du commerce.",
                    'ContactPage_FAQ_2_2_Answer': "Stationnement de votre véhicule sans autorisation ou sans vignette autorisée.",
                    'ContactPage_FAQ_2_3_Answer': "Stationnement de votre véhicule de manière à bloquer l’accès à un quai de livraison, un conteneur de déchets ou de recyclage, une porte d’entrée ou une entrée opérationnelle.",
                    'ContactPage_FAQ_2_4_Answer': "Stationnement de votre véhicule dans l’aire d’un commerce que vous n’avez pas fréquenté.",
                    'ContactPage_FAQ_2_5_Answer': "Pour plus de détails, n’hésitez pas à nous appeler sur les heures d’ouverture au 450-634-1808",

                    'ContactPage_FAQ_3_Question': "Pourquoi est-ce que j’ai reçu un avis de frais de stationnement, même si j’ai fréquenté le commerce associé au stationnement?",
                    'ContactPage_FAQ_3_1_Answer': "Vous ne respectez pas la réglementation du stationnement si vous avez stationné votre véhicule pour ensuite vous rendre ailleurs qu’au commerce relié au stationnement.",

                    'ContactPage_FAQ_4_Question': "Comment faire pour contester un avis?",
                    'ContactPage_FAQ_4_1_Answer': `Vous pouvez contester votre avis en envoyant un courriel à contestation@maxparksolutions.com`,
                    'ContactPage_FAQ_4_2_Answer': "Assurez-vous d’indiquer le numéro de l’avis et de joindre au courriel les pièces justificatives. Les pièces justificatives doivent correspondre à la date et l’heure de l’émission de l’avis. Ensuite, dans un délai de moins de 48 h, vous recevrez une réponse de notre équipe.",

                    'ContactPage_FormSection_Title': "Formulaire de contact",
                    'ContactPage_FormSection_Txt': "Remplissez le formulaire de contact pour communiquer avec notre équipe.",
                    'ContactPage_FormSection_Txt2': "Il nous fera plaisir de discuter de votre projet et de vous soumettre notre meilleure offre de services.",


                    'Footer_Section_1_Title': "Siège social",
                    'Footer_Section_1_1_Txt': "3310 100e Avenue",
                    'Footer_Section_1_2_Txt': "Bureau 225",
                    'Footer_Section_1_3_Txt': "Laval, Québec, H7T-0J7",
                    'Footer_Section_1_4_Txt': "Tél. : 450-634-1808",

                    'Footer_Section_2_Title': "Informations",
                    'Footer_Section_2_1_Txt': "Nos services",
                    'Footer_Section_2_2_Txt': "Affichage et signalisation",
                    'Footer_Section_2_3_Txt': "Patrouilles",
                    'Footer_Section_2_4_Txt': "Avis de frais de stationnement",
                    'Footer_Section_2_5_Txt': "Gestion de la circulation",

                    'Footer_Section_3_Title': "Foire aux questions",
                    'Footer_Section_3_1_Txt': "Mon véhicule a été remorqué",
                    'Footer_Section_3_2_Txt': "Agent de circulation durant des travaux",
                    'Footer_Section_3_3_Txt': "Règlements sur le stationnement privé",
                    'Footer_Section_3_4_Txt': "Gestion de crise",

                    'Footer_Section_4_Title': "Assitance d'urgence",
                    'Footer_Section_4_Title_Accent': "24h/7",
                    'Footer_Section_4_1_Txt': "Contactez l’assistance technique",
                    'Footer_Section_4_2_Txt': "Contactez le support",

                    // ADMIN SEARCH PAGE

                    'Admin_SearchPage_Search_Section_Title': "Filtre de résultats",
                    'Admin_SearchPage_Search_Section_Txt': "Veuillez cliquer sur la section pour avoir des propositions.",

                    'Admin_SearchPage_SearchResults_No_Search_Title_Txt': "Faites une recherche pour afficher un résultat.",
                    'Admin_SearchPage_SearchResults_No_Results_Title_Txt': "Aucun résultat trouvé avec vos paramètres.",
                    'Admin_SearchPage_SearchResults_Start_Search_Btn': "Débuter une recherche",

                    // ADMIN DASHBOARD
                    'Dashboard_Common_Dashboard': "Tableau de bord",
                    'Dashboard_Common_Admin': "Administration",
                    'Dashboard_Common_App': "Application",
                    'Dashboard_Common_Apps': "Applications",
                    'Dashboard_Common_Data': "Données",
                    'Dashboard_Common_Edit': "Modifier",
                    'Dashboard_Common_Delete': "Supprimer",
                    'Dashboard_Common_Cancel': "Annuler",
                    'Dashboard_Common_Save': "Enregistrer",
                    'Dashboard_Common_Close': "Fermer",
                    'Dashboard_Common_Filter': "Filtre",
                    'Dashboard_Common_Apply': "Appliquer",
                    'Dashboard_Common_Search': "Rechercher",
                    'Dashboard_Common_SearchPlaceholder': "Recherche...",
                    'Dashboard_Common_LocationPlaceholder': "Emplacement...",
                    'Dashboard_Common_Previous': "Précédent",
                    'Dashboard_Common_Next': "Suivant",
                    'Dashboard_Common_Current': "actuel",
                    'Dashboard_Common_New': "Nouveau",
                    'Dashboard_Common_2DaysAgo': "Il y a 2 jours",
                    'Dashboard_Common_Done': "Terminé",
                    'Dashboard_Common_Doing': "En cours",
                    'Dashboard_Common_Profit': "Profit",
                    'Dashboard_Common_Loss': "Perte",

                    'Dashboard_Greeting_Title': "Bienvenue !",
                    'Dashboard_Greeting_Subtitle': "Bienvenue dans la famille Max Park Solutions !",
                    'Dashboard_LatestActivity_Title': "Activité récente",
                    'Dashboard_LatestActivity_Today': "Aujourd'hui",
                    'Dashboard_LatestActivity_Month': "Mois",
                    'Dashboard_LatestActivity_GoogleReview_Title': "Révision de la demande du projet Google",
                    'Dashboard_LatestActivity_Complete3Hours': "À compléter dans 3 heures",
                    'Dashboard_LatestActivity_BusinessLogo_Title': "Création du logo de l'entreprise",
                    'Dashboard_LatestActivity_Complete2Days': "À compléter dans 2 jours",
                    'Dashboard_LatestActivity_BusinessResearch_Title': "Recherche sur le projet d'entreprise",
                    'Dashboard_LatestActivity_Due1Hour': "Échéance dans 1 heure",
                    'Dashboard_LatestActivity_Recruitment_Title': "Recrutement au département TI",
                    'Dashboard_LatestActivity_Riverfront_Title': "Soumettre le projet Riverfront",
                    'Global_Footer_Copyright': "© 2024–2026 Max Park Solutions. Tous droits réservés.",

                    'Dashboard_Card_IssuedTickets': "Avis émis",
                    'Dashboard_Card_Today': "Aujourd'hui",
                    'Dashboard_Card_Yesterday': "Hier",
                    'Dashboard_Card_Last24Hours': "Derni\u00e8res 24 h",
                    'Dashboard_Card_Previous24Hours': "24 h pr\u00e9c\u00e9dentes",
                    'Dashboard_Card_Contestations': "Contestations",
                    'Dashboard_Card_VehicleWatch': "Véhicules à surveiller",
                    'Dashboard_Card_PaymentConfirmations': "Paiements confirmés",
                    'Dashboard_Card_ReportingFreshness': "Fraîcheur reporting",
                    'Dashboard_Card_GrowthOverview': "Aperçu de la croissance",
                    'Dashboard_Card_GrowthSubtitle': "Croissance de 80 %",
                    'Dashboard_Card_SalesOverview': "Aperçu des ventes",
                    'Dashboard_Card_SalesSubtitle': "86 % de plus que l'année dernière",
                    'Dashboard_Card_UserActivations': "Activations d'utilisateurs",
                    'Dashboard_Card_UserSubtitle': "Utilisateurs annuels 24,65 k",
                    'Dashboard_Card_Transaction': "Transaction",
                    'Dashboard_Card_TransactionSubtitle': "5 878 transactions réussies",
                    'Dashboard_Card_TotalBalance': "Solde total",
                    'Dashboard_Timeline_Title': "Activité",
                    'Dashboard_Timeline_PreviousWeek': "Semaine précédente",
                    'Dashboard_Timeline_PreviousSevenDays': "7 jours pr\u00e9c\u00e9dents",
                    'Dashboard_Timeline_Loading': "Chargement des activités...",
                    'Dashboard_Timeline_Empty': "Aucune activité récente",
                    'Dashboard_Timeline_Series': "Nombre d'avis émis",
                    'Dashboard_Timeline_UnavailableNumber': "numéro non disponible",
                    'Dashboard_Timeline_Unit': "avis",

                    'Dashboard_RecentOrders_Title': "Commandes récentes",
                    'Dashboard_RecentOrders_Name': "Nom",
                    'Dashboard_RecentOrders_Date': "Date",
                    'Dashboard_RecentOrders_Quantity': "Quantité",
                    'Dashboard_RecentOrders_Value': "Valeur",
                    'Dashboard_RecentOrders_Rate': "Tarif",
                    'Dashboard_RecentOrders_StatusDone': "Terminé",
                    'Dashboard_RecentOrders_Product_1': "Chaussures Nike neuves jaunes",
                    'Dashboard_RecentOrders_Product_2': "Écouteurs Sony neufs",
                    'Dashboard_RecentOrders_Product_3': "Plante arbre doré",
                    'Dashboard_RecentOrders_Product_4': "Sac Marco M Kely",
                    'Dashboard_RecentOrders_Product_5': "T-shirt de marque Being Human",
                    'Dashboard_RecentOrders_Date_1': "16 août",
                    'Dashboard_RecentOrders_Date_2': "2 octobre",
                    'Dashboard_RecentOrders_Date_3': "21 mars",
                    'Dashboard_RecentOrders_Date_4': "31 décembre",
                    'Dashboard_RecentOrders_Date_5': "26 janvier",

                    'Dashboard_Sidebar_Back': "Retour",
                    'Dashboard_Sidebar_General': "Général",
                    'Dashboard_Sidebar_Home': "Accueil",
                    'Dashboard_Sidebar_Avis': "Avis",
                    'Dashboard_Sidebar_VehicleAlerts': "Alertes v\u00e9hicules",
                    'Dashboard_Sidebar_Contracts': "Contrats",
                    'Dashboard_Sidebar_Users': "Utilisateurs",
                    'Dashboard_Sidebar_Profiles': "Profils",
                    'Dashboard_Sidebar_Timesheets': "Activité terrain",
                    'Dashboard_Sidebar_Reports': "Rapports",
                    'Dashboard_Sidebar_Data': "Données",
                    'Dashboard_Sidebar_Agents': "Agents",
                    'Dashboard_Sidebar_HeatMap': "Carte thermique",
                    'Dashboard_Sidebar_History': "Historique",
                    'Dashboard_Sidebar_DailyHealth': "Santé quotidienne",
                    'Dashboard_Sidebar_Expenses': "Dépenses",
                    'Dashboard_Sidebar_MobileApp': "Application mobile",
                    'Dashboard_Sidebar_Configuration': "Configuration",

                    'Dashboard_Header_SearchPlaceholder': "Avis ou plaque",
                    'Dashboard_Header_AILabel': "Assistant de recherche MaxPark",
                    'Dashboard_Header_AIPlaceholder': "Demandez a MaxPark AI...",
                    'Dashboard_Header_AISubmit': "Envoyer la question",
                    'Dashboard_Header_AILoading': "Analyse des rapports Render/Postgres...",
                    'Dashboard_Header_AIError': "Impossible de charger la reponse depuis les rapports.",
                    'Dashboard_Notifications_Header': "Notifications",
                    'Dashboard_Notifications_Label': "Notifications",
                    'Dashboard_Notifications_HeaderNone': "Aucune notification",
                    'Dashboard_Notifications_HeaderOne': "Vous avez 1 notification",
                    'Dashboard_Notifications_HeaderMany': "Vous avez {{count}} notifications",
                    'Dashboard_Notifications_Loading': "Chargement des notifications...",
                    'Dashboard_Notifications_Empty': "Aucune activit\u00e9 r\u00e9cente",
                    'Dashboard_Notifications_LoadError': "Impossible de charger les notifications",
                    'Dashboard_Notifications_RetryLater': "Veuillez r\u00e9essayer plus tard",
                    'Dashboard_Notifications_RecentActivity': "Activit\u00e9 r\u00e9cente",
                    'Dashboard_Notifications_JustNow': "\u00c0 l'instant",
                    'Dashboard_Notifications_MinutesAgo': "Il y a {{count}} min",
                    'Dashboard_Notifications_HoursAgo': "Il y a {{count}} h",
                    'Dashboard_Notifications_DaysAgo': "Il y a {{count}} j",
                    'Dashboard_Notifications_DeliveryProcessing': "Livraison en traitement",
                    'Dashboard_Notifications_OrderComplete': "Commande terminée",
                    'Dashboard_Notifications_TicketsGenerated': "Avis générés",
                    'Dashboard_Notifications_TimesheetSubmitted': "Feuille de temps soumise",
                    'Dashboard_Notifications_DeliveryComplete': "Livraison terminée",
                    'Dashboard_Notifications_SeeAll': "Voir tout",
                    'Dashboard_Notifications_10MinutesAgo': "Il y a 10 minutes",
                    'Dashboard_Notifications_1HourAgo': "Il y a 1 heure",
                    'Dashboard_Notifications_3HoursAgo': "Il y a 3 heures",
                    'Dashboard_Notifications_1HrAgo': "Il y a 1 h",
                    'Dashboard_Notifications_6HoursAgo': "Il y a 6 heures",
                    'Dashboard_User_DisplayName': "Jean Dupont",
                    'Dashboard_UserProfile_Label': "Profil d'utilisateur",
                    'Dashboard_UserProfile_Logout': "Déconnexion",
                    'Dashboard_Bookmark_Title': "Favoris",
                    'Dashboard_Bookmark_AddNew': "Ajouter un favori",
                    'Dashboard_Bookmark_Empty': "Aucun résultat trouvé.",

                    'Dashboard_Breadcrumb_Users': "Utilisateurs",
                    'Dashboard_Breadcrumb_UserList': "Liste des utilisateurs",
                    'Dashboard_Breadcrumb_UserEdit': "Modifier l'utilisateur",
                    'Dashboard_Breadcrumb_AllContracts': "Tous les contrats",
                    'Dashboard_Breadcrumb_ContractsList': "Liste des contrats",
                    'Dashboard_Breadcrumb_GeneralInfo': "Informations générales",
                    'Dashboard_Breadcrumb_Add': "Ajouter",
                    'Dashboard_Breadcrumb_SupportTicket': "Billets de soutien",
                    'Dashboard_Breadcrumb_Miscellaneous': "Divers",
                    'Dashboard_Breadcrumb_JobDetails': "Détails du contrat",
                    'Dashboard_Breadcrumb_JobSearch': "Recherche de contrats",
                    'Dashboard_Breadcrumb_CardsView': "Vue cartes",
                    'Dashboard_Breadcrumb_SearchResult': "Résultats de recherche",
                    'Dashboard_Breadcrumb_FileManager': "Gestionnaire de fichiers",

                    'Dashboard_Users_Title': "Liste des utilisateurs",
                    'Dashboard_Users_Description': "Cette liste contient tous les utilisateurs du système.",
                    'Dashboard_Users_Create': "Créer un utilisateur",
                    'Dashboard_Users_Add': "Ajouter",
                    'Dashboard_Users_Status': "Statut",
                    'Dashboard_Users_Timesheet': "Activité terrain",
                    'Dashboard_Users_Employee': "Employé",
                    'Dashboard_Users_StartDate': "Date de début",
                    'Dashboard_Users_Hours': "Heures",
                    'Dashboard_Users_RowsPerPage': "Utilisateurs par page",
                    'Dashboard_Users_All': "Tous",
                    'Dashboard_Users_ChangePhoto': "Changer la photo",
                    'Dashboard_Users_FieldRequired': "Veuillez remplir ce champ",
                    'Dashboard_Users_LoadingTimesheets': "Chargement de l'activité terrain...",
                    'Dashboard_Users_NoTimesheets': "Aucune activité terrain trouvée.",
                    'Dashboard_Users_PartialTimesheetError': "Certaines données n'ont pas pu être chargées.",
                    'Dashboard_Users_TimesheetLoadError': "Impossible de charger l'activité terrain.",
                    'Dashboard_Users_StayOnPage': "Veuillez ne pas quitter la page s.v.p.",
                    'Dashboard_Users_CreatingUser': "Création de l'utilisateur",
                    'Dashboard_Users_UpdatingUser': "Mise à jour de l'utilisateur",
                    'Dashboard_Users_PleaseWait': "Veuillez patienter...",
                    'Dashboard_Users_Success': "Succès !",
                    'Dashboard_Users_Redirecting': "Vous serez redirigé vers la liste des utilisateurs automatiquement.",
                    'Dashboard_Users_ViewList': "Voir la liste des utilisateurs",
                    'Dashboard_Users_Loading': "Chargement des utilisateurs...",
                    'Dashboard_Users_PartialLoadError': "Certains profils n'ont pas pu être chargés.",
                    'Dashboard_Users_LoadError': "Impossible de charger les profils.",

                    'Dashboard_Contracts_New': "Nouveau contrat",
                    'Dashboard_Contracts_CreateNew': "Créer un contrat",
                    'Dashboard_Contracts_Loading': "Chargement des contrats...",
                    'Dashboard_Contracts_Empty': "Aucun contrat trouvé.",
                    'Dashboard_Contracts_ExportNotice': "Exporter avis",
                    'Dashboard_Contracts_DeleteConfirm': "Supprimer ?",
                    'Dashboard_Contracts_Extension': "Poste",

                    'Dashboard_Avis_DeleteConfirm': "Voulez-vous vraiment supprimer :",
                    'Dashboard_Avis_DeleteSuccess': "Suppression effectuée !",
                    'Dashboard_Avis_Status': "Statut",
                    'Dashboard_Avis_List': "Liste des avis",
                    'Dashboard_Avis_Title': "Avis",

                    'Dashboard_Report_SupportListTitle': "Liste des billets de soutien",
                    'Dashboard_Report_SupportListDescription': "Liste des billets ouverts par les clients",
                    'Dashboard_Report_HeatmapClients': "Clients",
                    'Dashboard_Report_TicketsList': "Liste des avis",
                    'Dashboard_Report_HeatmapSectors': "Secteurs",
                    'Dashboard_Report_HeatmapSectorMap': "Carte des secteurs",
                    'Dashboard_Report_DailyHealthTitle': "Santé quotidienne",
                    'Dashboard_Report_DailyHealthAudit': "Audit MaxPark",
                    'Dashboard_Report_GlobalStatus': "État global",
                    'Dashboard_Report_ReportOf': "Rapport du",
                    'Dashboard_Report_NoSummary': "Aucun résumé disponible.",
                    'Dashboard_Report_Critical': "Critiques",
                    'Dashboard_Report_CriticalSubtitle': "Points qui bloquent la production",
                    'Dashboard_Report_Warnings': "Avertissements",
                    'Dashboard_Report_WarningsSubtitle': "Risques et dérives à corriger",
                    'Dashboard_Report_HealthyItems': "Éléments sains",
                    'Dashboard_Report_HealthySubtitle': "Comportements validés",
                    'Dashboard_Report_QuickLinks': "Liens rapides",
                    'Dashboard_Report_QuickLinksSubtitle': "Accès direct aux cibles auditées",
                    'Dashboard_Report_Open': "Ouvrir",
                    'Dashboard_Report_FindingsBreakdown': "Répartition des constats",
                    'Dashboard_Report_FindingsBreakdownSubtitle': "Lecture rapide du niveau de santé",
                    'Dashboard_Report_RemainingWork': "Travail restant",
                    'Dashboard_Report_RemainingWorkSubtitle': "Volume relatif par chantier",
                    'Dashboard_Report_CriticalIssues': "Problèmes critiques",
                    'Dashboard_Report_SecurityPriorities': "Priorités sécurité",
                    'Dashboard_Report_RecommendedActions': "Actions recommandées",
                    'Dashboard_Report_Risk': "Risque",
                    'Dashboard_Report_Fix': "Correctif",
                    'Dashboard_Report_Order': "Commande",
                    'Dashboard_Report_Pending': "En attente",
                    'Dashboard_Report_Running': "En cours",
                    'Dashboard_Report_Smooth': "Stable",
                    'Dashboard_Report_Cancel': "Annulé",
                    'Dashboard_Report_Image': "Image",
                    'Dashboard_Report_Position': "Poste",
                    'Dashboard_Report_Salary': "Salaire",
                    'Dashboard_Report_Office': "Bureau",
                    'Dashboard_Report_Skill': "Compétence",
                    'Dashboard_Report_Extension': "Poste",

                    'Dashboard_ContractsReport_FilterSearch': "Rechercher...",
                    'Dashboard_ContractsReport_FilterLocation': "Emplacement...",
                    'Dashboard_ContractsReport_JobFilter': "Filtre des contrats",
                    'Dashboard_ContractsReport_RoleTitle': "Designer produit (UI/UX)",
                    'Dashboard_ContractsReport_CompanyLocation': "Viho - États-Unis",
                    'Dashboard_ContractsReport_Apply': "Postuler à cette offre",
                    'Dashboard_ContractsReport_Similar': "Offres similaires",
                    'Dashboard_ContractsReport_Area': "Secteur",
                    'Dashboard_ContractsReport_City': "Ville",
                    'Dashboard_ContractsReport_ListDescription': "Nous recherchons une personne expérimentée pour soutenir les opérations et contribuer à des projets clients.",
                    'Dashboard_ContractsReport_DescriptionTitle': "Description du poste",
                    'Dashboard_ContractsReport_Description': "Viho recherche un designer UI/UX polyvalent pour se joindre à son équipe. Nos designers contribuent aux projets clients à toutes les étapes, de la recherche utilisateur aux prototypes, jusqu'à la livraison des actifs finaux.",
                    'Dashboard_ContractsReport_Qualifications': "Qualifications",
                    'Dashboard_ContractsReport_AgencyExperience': "Expérience en agence",
                    'Dashboard_ContractsReport_Perks': "Avantages",
                    'Dashboard_ContractsReport_SaveJob': "Enregistrer cette offre",
                    'Dashboard_ContractsReport_Share': "Partager",

                    'Dashboard_SearchResults_Title': "Résultats de recherche",
                    'Dashboard_SearchResults_EmailHiddenLabel': "Courriel",
                    'Dashboard_SearchResults_Users': "Utilisateurs",
                    'Dashboard_SearchResults_Clients': "Clients",
                    'Dashboard_SearchResults_Images': "Images",
                    'Dashboard_SearchResults_Videos': "Vidéos",
                    'Dashboard_SearchResults_Maps': "Cartes",
                    'Dashboard_SearchResults_Settings': "Paramètres",
                    'Dashboard_SearchResults_Count': "Environ 6 000 résultats (0,60 seconde)",
                    'Dashboard_SearchResults_FieldChange': "Modification du champ : prix",
                    'Dashboard_SearchResults_GalleryAlt': "Galerie",
                    'Dashboard_SearchResults_Demo': "Démo",
                    'Dashboard_SearchResults_ImageDescription': "Texte de démonstration pour la galerie d'images.",

                    'Dashboard_Mobile_FileFilter': "Filtre de fichiers",
                    'Dashboard_Mobile_Storage': "Stockage",
                    'Dashboard_Mobile_LastOpen': "Dernière ouverture",
                    'Dashboard_Mobile_AddNew': "Ajouter",
                    'Dashboard_Mobile_Upload': "Téléverser",
                    'Dashboard_Mobile_AllFiles': "Tous les fichiers",
                    'Dashboard_Mobile_RecentlyOpened': "Fichiers récemment ouverts",
                    'Dashboard_Mobile_Folders': "Dossiers",
                    'Dashboard_Mobile_Files': "Fichiers",
                    'Dashboard_Mobile_UploadSuccess': "Fichier téléversé avec succès !",
                    'Dashboard_Mobile_SelectFileError': "Veuillez sélectionner au moins un fichier !",

                    'Dashboard_AddContract_ClientPlaceholder': "Nom du client ou de l'entreprise",
                    'Dashboard_AddContract_ClientRequired': "Le nom du client est requis",
                    'Dashboard_AddContract_ClientName': "Nom du client",
                    'Dashboard_AddContract_ProjectTitle': "Titre du projet",
                    'Dashboard_AddContract_ProjectRate': "Tarif du projet",
                    'Dashboard_AddContract_ProgressLevel': "Niveau d'avancement",
                    'Dashboard_AddContract_ProjectStatus': "Statut du projet",
                    'Dashboard_AddContract_Issues': "Problèmes",
                    'Dashboard_AddContract_Resolved': "Résolu",
                    'Dashboard_AddContract_Comment': "Commentaire",
                    'Dashboard_AddContract_Small': "Petit",
                    'Dashboard_AddContract_Medium': "Moyen",
                    'Dashboard_AddContract_Big': "Grand",
                    'Dashboard_AddContract_UploadProjectFile': "Téléverser un fichier de projet",
                    'Dashboard_AddContract_DropFile': "Déposer un fichier",
                    'Dashboard_AddContract_ProjectNamePlaceholder': "Nom du projet *",
                    'Dashboard_AddContract_TitleRequired': "Le titre est requis",
                    'Dashboard_AddContract_ProjectRatePlaceholder': "Entrez le tarif du projet",
                    'Dashboard_AddContract_SelectStatus': "Sélectionnez le statut",
                    'Dashboard_AddContract_SelectIssues': "Sélectionnez les problèmes",
                    'Dashboard_AddContract_ResolvedPlaceholder': "Ajouter les problèmes résolus",
                    'Dashboard_AddContract_CommentPlaceholder': "Ajouter un commentaire",

                    // ADMIN CONTRACTS PAGE

                    'Admin_Contract_ADD_Section_Title': "Ajout d'un contrat",
                    'Admin_Contract_Form_Date_Created': "Date de création",
                    'Admin_Contract_Form_Date_End': "Date de fin de contrat",
                    'Admin_Contract_Form_Service_Type': "Type de service",

                    //FORMS FIELDS
                    'Global_Field_Phone': "Téléphone",

                    //FORMS ERROR MESSAGE
                    'Global_Field_CannotBeEmpty': 'Ce champ ne peut être vide',
                    'Global_Field_EnterValidPhoneNumber': 'Veuillez entrer un numéro de téléphone valide',
                    'Global_Field_EnterValidExtension': 'Veuillez entrer une extension valide : #203',
                    'Global_Field_EnterValidEmail': 'Veuillez entrer une addresse courriel valide par exemple : Jon.Sh@mail.com',
                    'Global_Field_EnterValidPostalCode': 'Veuillez entrer le code postal ex :H1G 1A1',



                    'Dashboard_Sidebar_DailyHealth': 'Santé hebdomadaire',
                    'Dashboard_Report_DailyHealthTitle': 'Santé hebdomadaire',
                    'Dashboard_Report_WeeklyHealthTitle': 'Santé hebdomadaire',
                }
            },
            en: {
                translations: {
                    'MainPage_Intro_Txt': "Service complet de gestion de stationnement privé.",
                    'MainPage_Intro_Btn': 'Pay parking note',
                    'Dashboard': 'Dashboard',
                    'Default': 'Default',
                    'Ecommerce': 'Ecommerce',
                    'Widgets': 'Widgets',
                    'Chart': 'Chart',
                    'Applications': 'Applications',
                    'Ready to use Apps': 'Ready to use Apps'
                }
            }
        },
        fallbackLng: 'fr',
        debug: false,

        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
